import { ActionBase } from ".";

export class ClearAction extends ActionBase {

}